<template>
<div>
    <van-nav-bar
        title="药店直付码"
        
        
        
        @click-left="onClickLeft"
        @click-right="onClickRight"
        ></van-nav-bar>

  <div class="cashier-page">
    <div class="cashier-card">
      <!-- 日期和时间 -->
      <div class="date-time">
        <div class="date">{{ dateStr }}</div>
      </div>
      
      <!-- 分隔线 -->
      <div class="divider"></div>
      <!-- <van-divider dashed></van-divider> -->
      <!-- 提示信息 -->
      <div class="prompt">
        <div>提示:请使用<span class="highlight">理与算/普康宝</span>收银系统收银</div>
        <div class="highlight">每 60 秒自动刷新 ({{timeSecQty}})</div>
      </div>
      
      <!-- 条形码 -->
      <div class="barcode-container">
        <img :src="ppCodeData.lineBarImg" alt="条形码" class="barcode">
        <!-- <div class="barcode-number">8817 7500 1125 5687 56</div> -->
      </div>
      
      <!-- 二维码 -->
      <div class="qrcode-container">
        <img :src="ppCodeData.qrBarImg" alt="二维码" class="qrcode">
      </div>
      
    </div>
    
    <!-- 客服信息 -->
    <div class="service-info" style="display:none">
      <div class="service-phone">
        <i class="phone-icon">📞</i> 客服热线: 
      </div>
      <div class="service-time">
        (工作日: 9:00 - 20:00, 双休日: 9:00 - 18:00)
      </div>
    </div>
  </div>
  </div>  
</template>

<script>
export default {
  name: 'paymentCodePage',
  data() {
    return {
      dateStr: '06月17日',
      timeStr: '10:04:51',
      barcodeUrl: '', // 需要替换为实际的条形码图片URL
      qrcodeUrl: '', // 需要替换为实际的二维码图片URL
      timer: null,
      timeSecQty:60,
      lysCstUserId:null,
      b:null,
      c:null,

      ppCodeData:{
        payCode:'',
        lineBarImg:'',
        qrBarImg:''
      },
    }
  },
      // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      
        let {a,b,c} = this.$route.query; //a=lysCstUserId&b=12wei随机码&c=签名

        if(!a){
           alert("错误请请求");
        }else{

          this.lysCstUserId = a;

          this.b = b;

          this.c = c;

          this.viewPayCode("y");
        }
    },
  mounted() {
    // 初始化时间
    this.updateDateTime();
    
    // 设置定时器，每秒更新时间
    this.timer = setInterval(this.updateDateTime, 1000);

  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    //显示支付码
    viewPayCode(forceChangeFlag){
    
      if(!this.lysCstUserId){
          
          this.toLoginPage();

          return;
      }

			let data = {
				a:this.lysCstUserId,
        cardNo:"",
        b:this.b,
        c:this.c,
        forceChangeFlag:forceChangeFlag,
			}
        			
			this.$getRequestData20('getPaaCode20', data)
			.then(result =>{

				console.log(result);

				if(result.resultCode !== '0000'){
 					
					
					this.$toast.fail(result.msg);

					this.toLoginPage();
				}else{

					this.ppCodeData = result.bizData;

				}
			})
			.catch(err => {
				console.log(err);
				this.$toast.fail(err);
				
			})
		},

		toLoginPage(){
			
			 this.$router.push({ path: '/login/loginPage' });
		},

    updateDateTime() {
      const now = new Date();
      
      // 更新日期 - 格式：MM月DD日
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.dateStr = `${month}月${day}日`;
   

      this.timeSecQty = this.timeSecQty-1;
      if(this.timeSecQty==0){
        this.refreshPage();
        this.timeSecQty= 60;
      }
    },
    refreshPage() {
      // 这里可以添加刷新页面的逻辑
      // 例如重新获取数据等
      this.viewPayCode("y");
    },

    onClickLeft(){
        this.onClickRight();
    },
    onClickRight()
    {
      this.$router.push({ path: '/' })
    },      
  }
}
</script>

<style scoped>
html {
    background-color: #f5f5f5;
}
.cashier-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* background-color: #f5f5f5; */
  margin: 20px;
}

.cashier-card {
  width: 90%;
  max-width: 400px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.date-time {
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
}

.date {
  font-size: 18px;
  color: #333;
  margin-bottom: 5px;
}

.time {
  font-size: 36px;
  font-weight: bold;
  color: #000;
}

.divider {
    width: calc(100% + 40px);
    margin: 15px 0;
    border: 1px #ddd dashed;
}

.prompt {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}


.highlight {
  margin-top: 15px;
  color: #ff9800;
  font-weight: bold;
}

.barcode-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.barcode {
  width: 100%;
  margin-bottom: 5px;
  /* 如果没有实际图片，可以使用背景色模拟 */
  background-color: #f0f0f0;
}

.barcode-number {
  font-size: 16px;
  color: #333;
  letter-spacing: 1px;
}

.qrcode-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.qrcode {
  width: 200px;
  height: 200px;
  /* 如果没有实际图片，可以使用背景色模拟 */
  background-color: #f0f0f0;
}

.refresh-tip {
  font-size: 14px;
  margin-top: 10px;
}

.service-info {
  margin-top: 30px;
  text-align: center;
  color: #666;
}

.service-phone {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-bottom: 5px;
}

.phone-icon {
  margin-right: 5px;
  color: #ff9800;
}

.service-time {
  font-size: 14px;
}

</style>